import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled.div`
  justify-self: center;
  align-self: center;
`;
